@if (visible) {
  <div class="overlay spinner"
    >
    <div #spinnerContent class="spinner-content">
      <progress-symbol [mode]="mode" [value]="progress">
      </progress-symbol>
      @if (progressType === progressTypeEnum.FinalProgress) {
        <div class="text-wrapper">
          <p translate>
            i18n.progressOverlay.message.lines.one
          </p>
          <p translate>
            i18n.progressOverlay.message.lines.two
          </p>
        </div>
      }
    </div>
  </div>
}
